import { constructionToPathNameMap } from './getConstruction';
import { crmToPathNameMap } from './getCrm';
import { designToPathNameMap } from './getDesign';
import { feeToPathNameMap } from './getFee';
import { financeOssToPathNameMap } from './getFinanceOss';
import { financeToPathNameMap } from './getFinance';
import { IIPCompanyToPathNameMap } from './getIIPCompany';
import { iotToPathNameMap } from './getIot';
import { laborToPathNameMap } from './getLabor';
import { otherToPathNameMap } from './getOtherToPathName';
import { payToPathNameMap } from './getPay';
import { projectToPathNameMap } from './getProject';
import { purchaseToPathNameMap } from './getPurchase';
import { qualityToPathNameMap } from './getQuality';
import { safetyToPathNameMap } from './getSafety';
import { constructionLogToPathNameMap } from './getConstructionlog';
import { journalToPathNameMap } from './getJournal';
import { contractToPathNameMap } from './getContract';
import { constructionIndustryToPathNameMap } from './getConstructionIndustry';
import { taskToPathNameMap } from './getTask';
import { laborPartTimeToPathNameMap } from './getLaborPartTime';
import { mechanicalTeamToPathNameMap } from './getMechanicalTeam';
import { costToPathNameMap } from './getCostToPathName';
import { matToPathNameMap } from './getMat';
import { equipToPathNameMap } from './getUimsEquip';
import { checkToPathNameMap } from './getCheck';
export const getKxgcToPathNameMap = {
    ...costToPathNameMap,
    ...payToPathNameMap,
    ...qualityToPathNameMap,
    ...safetyToPathNameMap,
    ...financeToPathNameMap,
    ...financeOssToPathNameMap,
    ...crmToPathNameMap,
    ...IIPCompanyToPathNameMap,
    ...iotToPathNameMap,
    ...laborToPathNameMap,
    ...purchaseToPathNameMap,
    ...projectToPathNameMap,
    ...constructionToPathNameMap,
    ...feeToPathNameMap,
    ...designToPathNameMap,
    ...otherToPathNameMap,
    ...constructionLogToPathNameMap,
    ...journalToPathNameMap,
    ...contractToPathNameMap,
    ...constructionIndustryToPathNameMap,
    ...taskToPathNameMap,
    ...laborPartTimeToPathNameMap,
    ...mechanicalTeamToPathNameMap,
    ...matToPathNameMap,
    ...equipToPathNameMap,
    ...checkToPathNameMap,
};
